export default {
  projecttype: 'Project type',
  timeOut: 'Mission Countdown',
  all: 'All',
  text: 'Text',
  voice: 'Audio',
  picture: 'Image',
  video: 'Video',
  typeStr: 'Type: ',
  duration: 'Duration: ',
  day: 'Day',
  pubdate: 'Published 1 month ago',
  label: '233 people annotating',
  placeholder: 'ID or task ID',
  taskflag0: 'Paused',
  taskflag1: 'In progress',
  taskflag999: 'Completed',
  taskflagnil: 'Unknown',
  subStatus10: 'In progress',
  // subStatus11: ' Coming to an end',
  // subStatus12: 'In Quality Control',
  // subStatus13: 'Repairing',
  tag: 'Data annotation/labeling',
  collect: 'Data collection',
  thisType: 'Type of data',
  proLimit: 'Project limit',
  restricted: 'Restricted',
  open: 'Open',
  hasLimit: 'with permission',
  noLimit: 'without permission',
  please: 'Enter content here',
  task: 'task',
  datas: 'data',
  limit: 'limit',
  finished: 'finished',
  nodata: 'no data',
  mix: 'mixed task',
  nothing: 'none',
  release: 'release',
  just: 'just',
  ago: ' days ago',
  board: 'Board',
  proType: {
    recruit: 'Project recruitment',
    team: 'Team project',
    personal: 'Personal project',
    novice: 'Novice project'
  },
  releaseTime: 'Release time: ',
  fanhanbi: 'Fanhanbi: ',
  noData: 'No Data...',
  num: 'Remaining：',
  recruit1: 'Deadline',
  recruit2: 'Check',
  recruit3: 'Funcoins',
  recruit4: 'Individual',
  recruit5: 'Team',
  recruit6: 'Contact information',
  recruit7: 'Details',
  recruit8:	'Recruiting',
  recruit9:	'Recruitment finished',
  recruit10:	'Invalid item'
}



// WEBPACK FOOTER //
// ./src/lang/en/projects.js